<template>
  <div style="width: 100%; height: 100%">
    <v-layout row>
      <v-flex>
        <v-chip color="#788E98" text-color="white" class="chips" :selected="activeFilter === null"
          @click="capFilter(null)">{{ $t("zonesPage.allCaptains") }} ({{ totalCount }})
        </v-chip>
        <v-chip v-for="(count, index) in counts" :key="index" :color="count.color" :text-color="count.textColor"
          class="chips" :selected="activeFilter === index" v-if="index !== 'UNAVAILABLE'" @click="capFilter(index)">
          {{ statusLabel(index) }} ({{ count.count }})
        </v-chip>
      </v-flex>
    </v-layout>
    <gmap-map ref="mapRef" :center="{ lat: 33.5138, lng: 36.2765 }" :zoom="14" :options="options" class="gmap">
      <gmap-marker v-for="cap in test" :key="cap.id" :position="{ lat: cap.lat, lng: cap.lng }"
        :clickable="true" :draggable="false" alignment="top" :opacity="cap.stale ? 0.5 : 1"
        :icon="markerIcon(cap)" :title="markerTitle(cap)">
      </gmap-marker>
    </gmap-map>
    <div v-if="liveFeedDisconnected" class="live-feed-banner">
      {{ $t("zonesPage.liveFeedDisconnected") }}
    </div>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("zonesPage.pleaseStandBy") }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import socketEventsMixin from "@/mixins/socketEventsMixin.js";
import api from "@/constants/api.js";
import { GOOGLE_MAP_OPTIONS } from "@/constants/mapOptions";

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

// Shared by every marker icon; vue2-google-maps hands these straight to the
// Maps API, which only reads them.
const ICON_SIZE = Object.freeze({ width: 170, height: 96 });
const ICON_ANCHOR = Object.freeze({ x: 85, y: 96 });
// Socket location pings are buffered and applied to the map at this cadence.
const LOCATION_FLUSH_MS = 1000;
// Diffing re-sync against the backend list (the socket feed alone only ever
// loses captains: unknown ids, missed events, dead namespace).
const POLL_MS = 30000;
// A captain leaves the map only after this many consecutive polls report it
// offline/absent.
const REMOVE_AFTER_MISSES = 2;

export default {
  mixins: [socketEventsMixin],
  events() {
    return {
      captain_location_updated: this.updateLocations,
      "Timeline:captain_check": this.updateStatuses,
      disconnect: this.onSocketDisconnect,
      connect: this.onSocketConnect,
      error: this.onSocketError,
      connect_error: this.onSocketError,
    };
  },
  created() {
    // Non-reactive working state, deliberately NOT declared in data(): Vue
    // must not observe the icon cache or the ping buffer, and none of it is
    // rendered directly.
    this._iconCache = Object.create(null); // icon key -> icon object (same ref every render)
    this._locBuffer = new Map(); // captain id -> latest captain_location_updated payload
    this._captainInfo = Object.create(null); // captain id -> { username, fname, lname, icon, offline }
    this._fetchInFlight = false;
    this._fetchFailed = false;
    this._loadedOnce = false;
  },
  data() {
    return {
      sheet: false,
      dialog: false,
      open: false,
      // Shared frozen constant (owner item 1.1, full-detail base map); its
      // disableDefaultUI already covers the per-control flags this page set.
      options: GOOGLE_MAP_OPTIONS,
      colors: {
        UNAVAILABLE: "#464A5A",
        BUSY: "#2ECC71",
        FREE: "#2EB7B7",
        AT_DESTINATION: "#2ECC71",
      },
      counts: {
        BUSY: {
          color: "#2ECC71",
          count: 0,
          textColor: "white"
        },
        FREE: {
          color: "#2EB7B7",
          count: 0,
          textColor: "white"
        },
        AT_DESTINATION: {
          color: "#2ECC71",
          count: 0,
          textColor: "white"
        },
      },
      map: null,
      test: [],
      allData: [],
      filteredResults: [],
      test2: [],
      // Seconds since last ping before a marker is treated as stale; same
      // CAPTAIN_MAP_ONLINE_WINDOW setting the backend fetch uses (fallback 300).
      onlineWindow: 300,
      sweepTimer: null,
      flushTimer: null,
      pollTimer: null,
      // Status chip filter; null = all.
      activeFilter: null,
      liveFeedDisconnected: false,
    };
  },
  computed: {
    totalCount() {
      let total = 0;
      for (const status in this.counts) total += this.counts[status].count;
      return total;
    },
  },
  methods: {
    statusLabel(status) {
      const keys = {
        BUSY: "statusBusy",
        FREE: "statusFree",
        AT_DESTINATION: "statusAtDestination",
        UNAVAILABLE: "statusUnavailable",
      };
      return keys[status] ? this.$t("zonesPage." + keys[status]) : status;
    },
    toggleInfoWindow(marker, idx) {
      this.show_booking_marker = true;
      if (marker.destinations) {
        this.pickup_marker = {
          lat: marker.destinations[0]
            ? marker.destinations[0].pick_up_location.coordinates[1]
            : 0,
          lng: marker.destinations[0]
            ? marker.destinations[0].pick_up_location.coordinates[0]
            : 0,
        };
      }
      this.dropoff_markers = marker.destinations;

      this.infoWindowPos = {
        lat: marker.location.coordinates[1],
        lng: marker.location.coordinates[0],
      };
      this.infoContent = this.getInfoWindowContent(marker);

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    testy() {
      // let id = "";

      // for (let i = 0; i < this.allStationsData.length; i++) {
      // if (this.allStationsData[i].name === this.active_station) {
      // id = this.allStationsData[i].name;
      // console.log(this.active_station);
      // console.log(this.active_station.replace('Station ',''));
      // console.log('hiiii');
      // }
      // }
      // this.dialog = true;
      // let station = this.active_station.replace("Station ", "");
      // const url = this.api.ACTIONS.GET_STATION(station);
      // axios
      //   .get(url)
      //   .then((response) => {
      //     this.active_station_queue = response.data.data;
      //     console.log("active station queue");
      //     console.log(this.active_station_queue);
      //   })
      //   .finally(() => (this.dialog = false));
      // this.open = true;
    },
    escapeXml(text) {
      const safe = text === undefined || text === null ? "" : text;
      return String(safe)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
    },
    markerIcon(cap) {
      // Return the SAME object for the same (username|name|status|stale|version) key.
      // vue2-google-maps' `icon` prop has a shallow watcher, so a fresh literal
      // per render used to re-run setIcon() (a data-URI image reload) on every
      // marker on every render: that was the blinking and the lag.
      const fullName = `${cap.fname || ""} ${cap.lname || ""}`.trim();
      // The app version is part of the key so a captain who updates the app
      // gets a fresh bubble instead of keeping the old one until reload.
      const version = cap.version || "";
      const key = `${cap.username}|${fullName}|${cap.icon}|${cap.stale ? 1 : 0}|${version}`;
      let icon = this._iconCache[key];
      if (!icon) {
        icon = {
          url: this.formSvg(cap.username, fullName, cap.icon, cap.stale, version),
          scaledSize: ICON_SIZE,
          anchor: ICON_ANCHOR,
        };
        this._iconCache[key] = icon;
      }
      return icon;
    },
    markerTitle(cap) {
      // Native hover tooltip: username, name, app version and platform.
      const fullName = `${cap.fname || ""} ${cap.lname || ""}`.trim();
      return [cap.username, fullName, cap.version ? "v" + cap.version : "", cap.platform || ""]
        .filter(Boolean)
        .join(" - ");
    },
    formSvg(username, fullName, status, stale, version) {
      const safeUsername = username === undefined || username === null ? "" : username;
      const safeFullName = fullName === undefined || fullName === null ? "" : fullName;

      const numberText = this.escapeXml(safeUsername);
      const nameText = this.escapeXml(safeFullName);
      // Third line: the app version the captain last reported (empty when the
      // captain never reported one - never render a bare 'v').
      const versionText = version ? this.escapeXml("v" + String(version)) : "";

      // Truncate name to keep it clean (no squished text)
      const rawName = String(safeFullName).trim();
      const displayName = rawName.length > 18 ? rawName.slice(0, 17) + "…" : rawName;
      const displayNameText = this.escapeXml(displayName);

      const numberLen = String(safeUsername).length;
      const nameLen = displayName.length;
      const numberFont = clamp(26 - Math.max(0, numberLen - 5) * 2, 16, 26);
      const nameFont = clamp(14 - Math.max(0, nameLen - 12) * 0.4, 11, 14);

      // Stale (no ping within the online window) markers are greyed out.
      const bg = stale
        ? this.colors.UNAVAILABLE
        : (this.counts[status] && this.counts[status].color) ? this.counts[status].color : "#2ECC71";
      const fg = (this.counts[status] && this.counts[status].textColor) ? this.counts[status].textColor : "white";

      // Modern bubble marker (rounded rect + pointer + shadow)
      return 'data:image/svg+xml;utf8,' + encodeURIComponent(`<?xml version='1.0' encoding='utf-8'?>
<svg xmlns='http://www.w3.org/2000/svg' width='170' height='96' viewBox='0 0 170 96'>
  <defs>
    <filter id='shadow' x='-20%' y='-20%' width='140%' height='160%'>
      <feDropShadow dx='0' dy='6' stdDeviation='6' flood-color='#000000' flood-opacity='0.25'/>
    </filter>
  </defs>

  <g filter='url(#shadow)'>
    <path d='M22 10
             H148
             Q160 10 160 22
             V56
             Q160 68 148 68
             H100
             L85 90
             L70 68
             H22
             Q10 68 10 56
             V22
             Q10 10 22 10
             Z'
          fill='${bg}'
          stroke='rgba(255,255,255,0.28)'
          stroke-width='1.6'/>

    <!-- subtle highlight -->
    <path d='M22 12
             H148
             Q158 12 158 22
             V24
             Q158 28 154 28
             H16
             Q12 28 12 24
             V22
             Q12 12 22 12
             Z'
          fill='rgba(255,255,255,0.12)'/>
  </g>

  <text x='85' y='28'
        text-anchor='middle'
        style='font-family: Poppins, Arial, sans-serif; font-weight: 600; font-size: ${nameFont}px; fill: ${fg}; opacity: 0.95;'>
    ${displayNameText}
  </text>

  <text x='85' y='50'
        text-anchor='middle'
        style='font-family: Poppins, Arial, sans-serif; font-weight: 800; font-size: ${numberFont}px; fill: ${fg};'>
    ${numberText}
  </text>

  <text x='85' y='64'
        text-anchor='middle'
        style='font-family: Poppins, Arial, sans-serif; font-weight: 500; font-size: 10px; fill: ${fg}; opacity: 0.85;'>
    ${versionText}
  </text>
</svg>`);
    },
    close() {
      this.open = false;
    },
    findCaptainIndex(id) {
      const key = String(id);
      return this.test2.findIndex((cap) => String(cap.id) === key);
    },
    makeMarker(fields) {
      return Object.assign(
        {
          lat: 0,
          lng: 0,
          icon: "FREE",
          fname: "",
          lname: "",
          username: "",
          // Last app version / platform the captain reported ('' when unknown).
          version: "",
          platform: "",
          id: null,
          lastSeen: Date.now(),
          stale: false,
          // Consecutive polls that did not report this captain online.
          misses: 0,
        },
        fields
      );
    },
    updateStatuses(captain_id, id, status, driver) {
      // Backend publishes [captain_id, check_log_id, status, captain] on
      // check-in but only [captain_id, check_log_id, status] on UNAVAILABLE,
      // so `driver` is undefined there.
      if (captain_id === undefined || captain_id === null || !status) return;
      const key = String(captain_id);
      const info = this._captainInfo[key] || (this._captainInfo[key] = {});
      if (driver) {
        info.username = driver.username;
        info.fname = driver.first_name;
        info.lname = driver.last_name;
        // The check-in event carries the whole Captain model; guard the keys so
        // an older realtime build without them does not blank a known value.
        if (driver.version !== undefined) info.version = driver.version || "";
        if (driver.platform !== undefined) info.platform = driver.platform || "";
      }
      const idx = this.findCaptainIndex(key);
      const cap = idx === -1 ? null : this.test2[idx];

      if (status === "UNAVAILABLE") {
        // Checked out: grey it now; the poll's consecutive-miss rule removes it.
        info.offline = true;
        if (cap && !cap.stale) cap.stale = true;
      } else {
        info.offline = false;
        info.icon = status;
        if (cap) {
          cap.icon = status;
          cap.stale = false;
          cap.lastSeen = Date.now();
          if (driver) {
            cap.username = driver.username;
            cap.fname = driver.first_name;
            cap.lname = driver.last_name;
            if (driver.version !== undefined) cap.version = driver.version || "";
            if (driver.platform !== undefined) cap.platform = driver.platform || "";
          }
        }
        // Unknown captain with no coordinates: nothing to place yet. Its next
        // location ping (or the poll) adds it with this status and name.
      }
      this.refreshView();
    },
    updateLocations(data) {
      // The real-time service broadcasts every captain ping to the whole users
      // namespace (~1/s per moving captain). Keep only the latest payload per
      // captain here; flushLocations() applies them once a second.
      if (!data || data.captain_id === undefined || data.captain_id === null) return;
      this._locBuffer.set(String(data.captain_id), data);
    },
    flushLocations() {
      if (!this._locBuffer.size) return;
      const now = Date.now();
      let changed = false;

      this._locBuffer.forEach((data, key) => {
        const coords = data.location && data.location.coordinates;
        if (!coords || coords.length < 2) return;
        const lng = Number(coords[0]);
        const lat = Number(coords[1]);
        if (isNaN(lat) || isNaN(lng)) return;

        const info = this._captainInfo[key];
        const idx = this.findCaptainIndex(key);
        if (idx !== -1) {
          const cap = this.test2[idx];
          cap.lng = lng;
          cap.lat = lat;
          cap.lastSeen = now;
          // A ping does not un-grey a captain the backend says is checked out.
          if (cap.stale && !(info && info.offline)) {
            cap.stale = false;
            changed = true;
          }
          return;
        }

        // Captain that came online after page load: place it now instead of
        // waiting for F5. Only ids the backend vouched for (a poll row or a
        // check-in event) are trusted - a bare ping from an unknown id (not
        // approved, or checked out while the app still streams) must not
        // paint a false "online" marker until the poll corrects it.
        if (!info || info.offline) return;
        const pingName = String(data.captain_name || "").trim();
        const space = pingName.indexOf(" ");
        this.test2.push(
          this.makeMarker({
            id: data.captain_id,
            lat,
            lng,
            icon: (info && info.icon) || "FREE",
            username: info && info.username !== undefined ? info.username : "",
            fname: info && info.fname !== undefined ? info.fname : space === -1 ? pingName : pingName.slice(0, space),
            lname: info && info.lname !== undefined ? info.lname : space === -1 ? "" : pingName.slice(space + 1),
            version: (info && info.version) || "",
            platform: (info && info.platform) || "",
            lastSeen: now,
          })
        );
        changed = true;
      });
      this._locBuffer.clear();

      if (changed) this.refreshView();
    },
    capFilter(value) {
      this.activeFilter = value || null;
      this.applyFilter();
    },
    applyFilter() {
      // test2 is the unfiltered master list; test is what the map renders.
      // Both hold the same marker objects, so in-place updates show either way.
      const filter = this.activeFilter;
      this.test = filter ? this.test2.filter((cap) => cap.icon === filter) : this.test2.slice();
    },
    recount() {
      for (const status in this.counts) this.counts[status].count = 0;
      for (let i = 0; i < this.test2.length; i++) {
        const cap = this.test2[i];
        if (!cap.stale && this.counts[cap.icon]) this.counts[cap.icon].count++;
      }
    },
    refreshView() {
      this.applyFilter();
      this.recount();
    },
    fetchOnlineWindow() {
      // Same CAPTAIN_MAP_ONLINE_WINDOW setting the backend uses to decide who
      // is online in the initial fetch; keep the 300s fallback on any failure.
      axios
        .get(this.api.ACTIONS.SETTINGS, {
          params: {
            key: "CAPTAIN_MAP_ONLINE_WINDOW",
          },
        })
        .then((res) => {
          const val = parseInt(res.data.data && res.data.data["CAPTAIN_MAP_ONLINE_WINDOW"], 10);
          if (!isNaN(val) && val > 0) this.onlineWindow = val;
        })
        .catch(() => { });
    },
    fetchCaptains() {
      // Initial load, socket-reconnect re-sync and the periodic poll all come
      // through here and MERGE into the existing markers. The map is never
      // cleared: a slow or failed request used to wipe it.
      if (this._fetchInFlight) return;
      this._fetchInFlight = true;
      const initial = !this._loadedOnce;
      if (initial) this.dialog = true;
      const startedAt = Date.now();

      axios
        .get(this.api.ACTIONS.GET_ALL_CAPTAINS)
        .then((response) => {
          const raw = response.data && response.data.data;
          const rows = Array.isArray(raw) ? raw : raw && typeof raw === "object" ? Object.values(raw) : [];
          this.allData = rows;
          this._loadedOnce = true;
          this._fetchFailed = false;
          this.mergeCaptains(rows, startedAt);
        })
        .catch((err) => {
          // Keep whatever is on the map; say so once per failure streak so a
          // dead backend does not toast every 30s.
          console.warn("[CaptainsMap] captains fetch failed, keeping last known markers", err);
          if (!this._fetchFailed && window.getApp) {
            window.getApp.$emit("SHOW_TOAST", this.$t("zonesPage.captainsFetchFailed"), "red");
          }
          this._fetchFailed = true;
        })
        .finally(() => {
          this._fetchInFlight = false;
          // The stand-by dialog belongs to the very first attempt only; a dead
          // backend must not re-flash it on every 30 s poll.
          this._loadedOnce = true;
          this.dialog = false;
        });
    },
    mergeCaptains(rows, startedAt) {
      const now = Date.now();
      const seen = Object.create(null);

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        if (!row || row.id === undefined || row.id === null) continue;
        const key = String(row.id);

        // Remember every approved captain, offline ones included, so a ping
        // from a captain not yet on the map is placed with its real
        // username/name rather than the ping's bare captain_name.
        const info = this._captainInfo[key] || (this._captainInfo[key] = {});
        info.username = row.username;
        info.fname = row.first_name;
        info.lname = row.last_name;
        // NULL until the captain's app reports a version; normalise to ''.
        info.version = row.version || "";
        info.platform = row.platform || "";

        const coords = row.location && row.location.coordinates;
        const online =
          !!row.captain_status && row.captain_status !== "UNAVAILABLE" && !!coords && coords.length >= 2;
        if (!online) {
          // A check-in / ping that landed while this request was in flight is
          // fresher than the snapshot (the backend also caches it for 3 s):
          // do not mark such a captain offline on stale data.
          const liveIdx = this.findCaptainIndex(key);
          const live = liveIdx === -1 ? null : this.test2[liveIdx];
          if (!(live && live.lastSeen > startedAt)) info.offline = true;
          continue;
        }
        info.offline = false;

        info.icon = row.captain_status;
        seen[key] = true;
        const idx = this.findCaptainIndex(key);
        if (idx === -1) {
          this.test2.push(
            this.makeMarker({
              id: row.id,
              lat: coords[1],
              lng: coords[0],
              icon: row.captain_status,
              fname: row.first_name,
              lname: row.last_name,
              username: row.username,
              version: row.version || "",
              platform: row.platform || "",
              lastSeen: now,
            })
          );
          continue;
        }

        const cap = this.test2[idx];
        // A socket ping that landed while this request was in flight is
        // fresher than the snapshot: do not move the marker backwards.
        if (!(cap.lastSeen > startedAt)) {
          cap.lat = coords[1];
          cap.lng = coords[0];
        }
        cap.icon = row.captain_status;
        cap.fname = row.first_name;
        cap.lname = row.last_name;
        cap.username = row.username;
        cap.version = row.version || "";
        cap.platform = row.platform || "";
        cap.lastSeen = now;
        cap.stale = false;
        cap.misses = 0;
      }

      // Anyone on the map the backend did not report online: grey on the first
      // miss, remove after REMOVE_AFTER_MISSES consecutive misses.
      for (let i = this.test2.length - 1; i >= 0; i--) {
        const cap = this.test2[i];
        const key = String(cap.id);
        // Fresher than the snapshot (see above): not a miss.
        if (seen[key] || cap.lastSeen > startedAt) continue;
        const info = this._captainInfo[key] || (this._captainInfo[key] = {});
        info.offline = true;
        cap.misses = (cap.misses || 0) + 1;
        if (cap.misses >= REMOVE_AFTER_MISSES) this.test2.splice(i, 1);
        else if (!cap.stale) cap.stale = true;
      }

      this.refreshView();
    },
    sweepStaleMarkers() {
      // Grey out markers not pinged within the online window. Removal is the
      // poll's job (consecutive-miss rule in mergeCaptains); deleting here
      // left nothing to bring a captain back.
      const now = Date.now();
      const staleAfterMs = (this.onlineWindow || 300) * 1000;
      let changed = false;

      for (let i = 0; i < this.test2.length; i++) {
        const cap = this.test2[i];
        const age = now - (cap.lastSeen || 0);
        if (age >= staleAfterMs && !cap.stale) {
          cap.stale = true;
          changed = true;
        }
      }
      if (changed) this.recount();
    },
    onSocketDisconnect() {
      this.liveFeedDisconnected = true;
    },
    onSocketError(err) {
      // Namespace auth failure / connection error: the feed is dead even though
      // `disconnect` never fires. Show the banner; the poll keeps the map alive.
      console.warn("[CaptainsMap] live feed error", err);
      this.liveFeedDisconnected = true;
    },
    onSocketConnect() {
      if (!this.liveFeedDisconnected) return;
      this.liveFeedDisconnected = false;
      // Re-sync: anything can have changed while the live feed was down.
      this.fetchCaptains();
    },
  },
  mounted() {
    this.fetchOnlineWindow();
    this.fetchCaptains();
    if (this.socket && this.socket.disconnected) this.liveFeedDisconnected = true;
    this.flushTimer = setInterval(this.flushLocations, LOCATION_FLUSH_MS);
    this.pollTimer = setInterval(this.fetchCaptains, POLL_MS);
    this.sweepTimer = setInterval(this.sweepStaleMarkers, 30000);
  },
  beforeDestroy() {
    if (this.flushTimer) clearInterval(this.flushTimer);
    if (this.pollTimer) clearInterval(this.pollTimer);
    if (this.sweepTimer) clearInterval(this.sweepTimer);
  },
};
</script>
<style lang="scss" scoped>
.gmap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  inset-inline-start: 0px;
}

// removed: search + filters panel

// .my-input {
// .v-input__control {
//    .v-input__slot {

//      border-radius: 15px !important;
//    }
//   }
// }
// .my-input > .v-input__control > .v-input__slot {
//   border-radius: 15px;
// }
// .v-input__slot {
//   border-radius: 15px;
// }

.vue-map-hidden {
  display: block !important;
}

.live-feed-banner {
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  background: #e53935;
  color: white;
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

// removed: vehicle type / driver type / stations filter styles

.chips {
  z-index: 1;
}

.v-chip:hover * {
  cursor: pointer !important;
}

.slidein {
  max-height: 200px;
  padding: 2em 3em;
  position: fixed;
  z-index: 100;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  background: white;
  height: 100%;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.5s ease-in-out;
  display: flex !important;
  flex-direction: column;
  overflow-y: scroll;
}

/* before the element is shown, start off the screen to the right */
.slide-enter,
.slide-leave-active {
  bottom: -100%;
}

.close-btn {
  border: none;
  font-weight: bold;
  font-size: 2em;
  background: transparent;
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  padding: 0.5em;
}

/* General styles unrelated to slide in */
body {
  font-family: "Mulish", sans-serif;
}

.toggle {
  margin: 1em;
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.scrl {
  display: flex !important;

  overflow-y: scroll;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}

.captains-list {
  width: 100%;
  max-height: 350px;
  min-height: 50px;
  float: inline-start;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.captain {
  width: 100%;
  float: inline-start;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;

  img {
    height: 32px;
    width: 32px;
    float: inline-start;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }

  .queue {
    color: #788e98;
  }
}

.all-stations {
  height: auto;
  max-height: 350px;
  width: 100%;
  border-radius: 10px;
  height: max-content;
  bottom: 0;
  overflow: auto;
}

.filter-v-select {
  margin-bottom: 20px;
  height: auto;
}

.station {
  bottom: 1px;
  max-height: 160px;
  min-height: 150px;
  width: 1400px;
  border-radius: 15px;
  margin-inline-start: 50px;
  height: max-content;
  position: absolute;
}
</style>
